import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { Form } from "antd";
import {
  emptyErrorObj,
  resetSubmitLeadRemarkss,
} from "../../actionCreator/leadDetailsActionCreator";
import { SAVE_CLIENT_REMARKS_ERROR } from "../../actionType/leadDetailsType";
import { useAlert } from "../../context/AlertProvider";
import ActivityTime from "./ActivityTime";

const Tasks = ({ setActiveTab, setTask, setEditTask, setAddTask }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { showAlert } = useAlert();

  const errObj = useSelector((state) => state.LeadDetailsReducer.errObj);

  const leadRemarksSubmitted = useSelector(
    (state) => state.LeadDetailsReducer.saveleadRemarks,
  );
  const leadRemarksDetails = useSelector(
    (state) => state.LeadDetailsReducer.leadRemarksDetails,
  );

  useEffect(() => {
    if (!!Object.keys(errObj).length) {
      showAlert("error", errObj[SAVE_CLIENT_REMARKS_ERROR]?.message);
      dispatch(resetSubmitLeadRemarkss());
      dispatch(emptyErrorObj());
    }
  }, [errObj]);

  useEffect(() => {
    if (Object.keys(leadRemarksSubmitted).length) {
      showAlert("success", "Remarks Submitted.");
      dispatch(resetSubmitLeadRemarkss());
      dispatch(emptyErrorObj());
      form.resetFields();
      setTask();
    }
  }, [dispatch, form, leadRemarksSubmitted, setTask, showAlert]);

  useEffect(() => {
    if (!Object.keys(leadRemarksDetails).length) return;
    const currentTaskType = leadRemarksDetails.type || leadRemarksDetails.title;
    form.setFieldsValue({
      type: currentTaskType,
      title: leadRemarksDetails.title,
      status: leadRemarksDetails.status,
      remarks: leadRemarksDetails.remarks,
      interactionDate: moment(leadRemarksDetails.interactionDate),
    });
    setTask(currentTaskType);
  }, [leadRemarksDetails]);

  return (
    <div className="p-20">
      <ActivityTime
        setActiveTab={setActiveTab}
        setEditTask={setEditTask}
        setAddTask={setAddTask}
      />
    </div>
  );
};

export default Tasks;
